export default "__VITE_ASSET__TpuKV7Ql__"